import moment from "moment";
import HealthcareProfessionalInformationGuide from "./../../pages/PatientMaterial/Brochures/PDFs/HealthcareProfessionalInformationGuide.pdf";

const PharmacistConfirmation = ({
  selectedBrand,
  form,
  handleChangeCheckBox,
  isEditOrder,
  pharmacyUser,
  handleChange,
  validateFields,
  isSubmit,
  isOrderCycleDisableLogic = false,
  id = "",
}) => {
  return (
    <>
      <div className="second-title aqua-deep mt-5">Pharmacist Confirmation</div>
      <div className="mt-4 inputs-div">
        <label
          htmlFor={`confirmation_1${id}`}
          className={
            form.confirmation_1 && isEditOrder
              ? "cursor-not-allowed custom-checkbox font-size-16 "
              : `custom-checkbox font-size-16 ` +
                (isSubmit && !validateFields.pharmacist_confirmation_1.isValid
                  ? "red-label"
                  : "")
          }
        >
          I confirm that I am ordering on behalf of a registered pharmacy and
          that lenalidomide will be dispensed in accordance with the risk
          minimisation procedures for lenalidomide, as specified by{" "}
          <b
            className={
              `font-size-16 ` +
              (isSubmit && !validateFields.pharmacist_confirmation_1.isValid
                ? "red-label"
                : "")
            }
          >
            {selectedBrand}
          </b>{" "}
          in the{" "}
          <a
            href={HealthcareProfessionalInformationGuide}
            target={"_blank"}
            rel="noreferrer"
            className={
              `font-size-16 ` +
              (isSubmit && !validateFields.pharmacist_confirmation_1.isValid
                ? "red-label"
                : "")
            }
          >
            Lenalidomide Healthcare Professional Information Guide
          </a>
          .
          <input
            type="checkbox"
            id={`confirmation_1${id}`}
            name="confirmation_1"
            checked={form.confirmation_1 || false}
            onChange={handleChangeCheckBox}
            disabled={isEditOrder}
          />
          <span className="checkmark" />
        </label>

        <label
          htmlFor={`confirmation_2${id}`}
          className={
            form.confirmation_2 && isEditOrder
              ? "cursor-not-allowed custom-checkbox font-size-16"
              : `custom-checkbox font-size-16 ` +
                (isSubmit && !validateFields.pharmacist_confirmation_2.isValid
                  ? "red-label"
                  : "")
          }
        >
          I confirm that treatment lengths will be limited to a maximum of 4
          weeks supply for women of childbearing potential and a maximum of 12
          weeks for males and women of non-childbearing potential patients. For
          women of child bearing potential dispensing will be within 7 days of
          the date of prescription
          <input
            type="checkbox"
            id={`confirmation_2${id}`}
            name="confirmation_2"
            checked={form.confirmation_2 || false}
            onChange={handleChangeCheckBox}
            disabled={isEditOrder}
          />
          <span className="checkmark" />
        </label>
      </div>
      <div className="inputs-div">
        <div className="row mt-5">
          <div className="row" style={{ justifyContent: "space-between" }}>
            <div
              className={
                `col prescriber-details-inputs aqua-deep ` +
                (isSubmit && !validateFields.pharmacist_name.isValid
                  ? "red-label"
                  : "")
              }
            >
              Pharmacist Name:*
              <input
                disabled={!isOrderCycleDisableLogic}
                maxLength={50}
                className={
                  !isOrderCycleDisableLogic
                    ? "cursor-not-allowed "
                    : "remove-outline "
                }
                value={
                  form.pharmacist_name ||
                  (!isOrderCycleDisableLogic
                    ? !!form?.order_cycle &&
                      form?.order_cycle[form?.order_cycle.length - 1]
                        ?.pharmacist_name
                    : "")
                }
                onChange={handleChange}
                name="pharmacist_name"
                placeholder="Pharmacist Name"
              />
            </div>
            <div className="col prescriber-details-inputs gray">
              Date:
              <input
                value={
                  form.created_date
                    ? moment(form.created_date).format("DD / MM / YYYY")
                    : moment().format("DD / MM / YYYY")
                }
                className="gray"
                disabled
              />
            </div>
          </div>
          <div className="row" style={{ justifyContent: "space-between" }}>
            <div className="col prescriber-details-inputs gray">
              GMS Number:
              <input
                value={pharmacyUser.gmsNumber || ""}
                className="gray"
                disabled
              />
            </div>
            <div className="col prescriber-details-inputs gray">
              Pharmacy Email Address:
              <input
                value={pharmacyUser.email || ""}
                className="gray"
                disabled
              />
            </div>
          </div>
          <div className="row" style={{ justifyContent: "space-between" }}>
            <div className="col prescriber-details-inputs gray">
              Phone Number
              <input
                className="gray"
                value={pharmacyUser.phone_number || ""}
                disabled
              />
            </div>
            <div className="col prescriber-details-inputs"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PharmacistConfirmation;
